import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectDetail from "./ProjectDetail";
import Particle from "../Atom";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
        Projects  <strong className="purple"> </strong>
        </h1>
        <p style={{ color: "white" }}>
        
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

        <Col md={4} className="project-card">
            <ProjectDetail
               imgPath={"https://i.postimg.cc/kXfdMLCC/homeblog.png"}
              isBlog={false}
              title="LiveBlog App"
              description="A Full-Stack blog website using MERN stack. This is a CRUD application to manage any blog."
               ghLink="https://github.com/Rutujalomate/blogapp"
               techstack="ReactJS,Chakra-UI,JS,Node JS,Express JS,MongoDB"

              demoLink="https://tubular-biscochitos-1400fb.netlify.app/"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectDetail
               imgPath={"https://i.postimg.cc/m2MF0NW7/myglamhome.png"}
              isBlog={false}
              title="Myglamm Clone"
              description="MyGlamm is an Indian e-commerce company that sells cosmetics and personal care products
                build with react.js,Chakra-UI and Js for backend nodejs,Express and mongoDB." 
                techstack="ReactJS,Chakra-UI,JS,Node JS,Express JS,MongoDB"
              ghLink="https://github.com/Rutujalomate/myglamm-clone/"
              demoLink="https://myladyshine.netlify.app/"
            />
          </Col>






          <Col md={4} className="project-card">
            <ProjectDetail
               imgPath={"https://i.postimg.cc/zDLHjdVW/Untitled.png"}
              isBlog={false}
              title="Shop.com Clone "
              description="shop.com marketplace offers excellent clothes, beauty, health, and nutrition deals"
               ghLink="https://github.com/yadav123yo/FaydaBazar"
               techstack="ReactJS,Chakra-UI,JS,Node JS,Express JS,MongoDB"

              demoLink="https://fayda-bazar.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectDetail
               imgPath={"https://camo.githubusercontent.com/67f980ce79ab11400e46fe8028de228a333fa88603c51ce59d2fe4b0edb50596/68747470733a2f2f692e696d6775722e636f6d2f324450516576592e706e67"}
              isBlog={false}
              title="Dermstore.com Clone"
              description="Dermstore is US web store which sells cosmetics and skin 
              care products. In 2021, it was acquired by THG plc from Target Corporation 
              for £260.9m and migrated onto the company's Ingenuity e-commerce platform."
               ghLink="https://github.com/1Gireesh/Dermstore-full-stack-clone"
               techstack="ReactJS,Chakra-UI,JS,Node JS,Express JS,MongoDB"

              demoLink="https://celadon-piroshki-a9a67d.netlify.app/"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectDetail
               imgPath={"https://user-images.githubusercontent.com/42139446/115157389-99c87a80-a0a6-11eb-9f8c-317d1a5ff39b.png"}
              isBlog={false}
              title="Milap Clone"
              description="Milaap is an online crowdfunding platform
                build with react.js, Material-UI,Chakra-UI and Js. 
                Have features which allows  anyone across India to raise funds for healthcare, education."
              ghLink="https://github.com/Rutujalomate/subsequent-cent-9512"
              techstack="ReactJS,Chakra-UI,JS,Node JS,Express JS,MongoDB"

              demoLink="https://melodious-souffle-f90b75.netlify.app/"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectDetail
             imgPath={"https://i.postimg.cc/Lsw-26V2K/nbs.png"}
              isBlog={false}
              title="Nature Basket Clone"
              description="Nature's Basket is an Indian grocery delivery chain of retail stores focused on gourmet food 
              build with HTML,CSS and Js."
              ghLink="https://github.com/aaryansinha16/Nature-Basket-WEB-18"
              demoLink="https://teal-pixie-015fbb.netlify.app/"
              techstack="HTML,CSS,JS"

              name="GitHub"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectDetail
              imgPath={"https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcRBv-AW4urhDNvxaW4aLeTbRiZxLYLVlLeuS1FU3wQdjLo2MUC0"}
              isBlog={false}
              title="Food App"
              description="It is a Food website that allows user to order food online  .build this website
              using different techtools like HTML,CSS and JS."
              ghLink="https://github.com/Rutujalomate/foodapp"
              techstack="HTML,CSS,JS"

              demoLink="https://lustrous-hamster-41b10e.netlify.app/"              
            />
          </Col>



          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
